namespace SolovisGateway.Admin.DataEnvironments {

    export class AddDataEnvironmentEditorDialog {

        private _saveCallback;

        private _addDataEnvironmentEditor: AddDataEnvironmentEditorControl;
        private _dialogWindow: Solovis.UI.Dialog;

        constructor(options) {
            var self = this;

            var desiredWidth = Math.min($(window).width() * .8, 600);
            var desiredHeight = Math.min($(window).height() * .8, 600);

            var minWidth = 100;
            var minHeight = 100;

            this._saveCallback = options.saveCallback ? options.saveCallback : null;

            var editorDiv = $("<div>")
                .css("min-height", "75px");

            this._addDataEnvironmentEditor = new SolovisGateway.Admin.DataEnvironments.AddDataEnvironmentEditorControl({
                controlHost: editorDiv
            });

            this._addDataEnvironmentEditor.setAsCurrentControl();

            this._dialogWindow = new Solovis.UI.Dialog({
                container: editorDiv,

                title: "Add Data Environment",

                modal: true,
                center: true,
                actions: ["Close"],
                autoOpen: true,
                destroyOnClose: true,
                width: desiredWidth,
                minWidth: minWidth,
                minHeight: minHeight,
                height: desiredHeight,
                buttons: [
                    {
                        label: "Save",
                        click: function () {
                            self._save();
                        }
                    },
                    {
                        label: "Cancel",
                        click: function () {
                            self._dialogWindow.close();
                        }
                    }
                ]
            });
        }




        public _cancel() {
            this._dialogWindow.close();
        }

        public _save() {
            var self = this;

            if (this._addDataEnvironmentEditor.isValid()) {

                var model = this._addDataEnvironmentEditor._getAddNewDataEnvironmentModel();
                Solovis.Rpc.invokeAndWait("~/Admin/DataEnvironmentAdmin/AddNewDataEnvironment",
                    {
                        model: model
                    },
                    function (response, success) {
                        if (success) {
                            if (response.result.modelIsValid) {
                                var savedDataEnvironmentEditorModel = response.result.modelResult;
                                
                                // Jump to the info page for the new data environment.
                                window.location.href = Solovis.resolveUrl("~/Admin/DataEnvironmentAdmin/Info/" + savedDataEnvironmentEditorModel.id);                                
                            }
                            else {
                                self._addDataEnvironmentEditor._formBuilder.applyErrors(response.result.errors);
                            }
                        }
                    });
            }
        }


        public static showDialog(options) {
            var dialog = new SolovisGateway.Admin.DataEnvironments.AddDataEnvironmentEditorDialog(options);
        }

    }

}
